import { useCurrency } from '@/contexts/CurrencyContext';
import type { Listing } from '@/services/api';
import { useMemo } from 'react';

interface MarketDifference {
    text: string;
    isAbove: boolean;
    amount: string;
    direction: 'above' | 'below';
}

export const useMarketDifference = (listing: Listing): MarketDifference | null => {
    const { formatPrice } = useCurrency();

    return useMemo(() => {
        const soldAvgPrice = listing.market_status?.sold_avg_price;
        if (!soldAvgPrice) return null;

        const difference = listing.current_price - soldAvgPrice;
        const absDifference = Math.abs(difference);
        const isAbove = difference > 0;

        return {
            text: `Currently ${formatPrice(absDifference)} ${isAbove ? 'above' : 'below'} Sold Market Average`,
            isAbove,
            amount: formatPrice(absDifference),
            direction: isAbove ? 'above' : 'below'
        };
    }, [listing.current_price, listing.market_status?.sold_avg_price, formatPrice]);
}; 